import { debugLog } from 'shared/logger/debugLog';
import { DocumentUpdatePayload } from 'shared/dtos/out/document';
import { toDocumentPatchOutDto } from 'shared/dtos/out/documentMappers';
import { IDocumentUploader } from './uploadDocument';

export type UploadDocumentChangeResponse = {
  document?: Record<string, unknown>;
  signedRequest?: unknown;
};

export type UploadDocumentChange = (
  uploader: IDocumentUploader,
  url: string,
  data: DocumentUpdatePayload
) => Promise<UploadDocumentChangeResponse | false>;

export const uploadDocumentChange: UploadDocumentChange =
  async function _uploadDocumentChange(
    uploader: IDocumentUploader,
    url: string,
    data: DocumentUpdatePayload
  ): Promise<UploadDocumentChangeResponse | false> {
    try {
      const patchDto = toDocumentPatchOutDto(data);
      const response = await uploader.PUT(url, patchDto);
      debugLog('[uploadDocumentChange] API response (what backend returned)', response);
      return response && typeof response === 'object' ? response : {};
    } catch (e) {
      return false;
    }
  };
